import http from "@/utils/http";


export const VisitorApplyApi = {
    saveApply(data) {
		return http.post(`/server/visitor/apply/save`, data);
	},
	selectVisitorPage(params) {
		return http.get(`/server/visitor/apply/page`,params);
	},
    agreeApproval(data){
		return http.post(`/server/visitor/apply/agreeApproval`, data);
	},
    rejectApproval(data){
        return http.post(`/server/visitor/apply/rejectApproval`, data);
    },
    confirmApproval(data){
        return http.post(`/server/visitor/apply/confirmApproval`, data);
    },
    leaveVisit(data){
        return http.post(`/server/visitor/apply/leaveVisit`, data);
    },
    deleteApply(id){
        return http.get(`/server/visitor/apply/delete/${id}`);
    },
    batchDeleteApply(data){
        return http.post(`/server/visitor/apply/batchDelete`, data);
    },
    queryApprovalLog(id){
        return http.get(`/server/visitor/apply/queryApprovalLog/${id}`);
    },
    selectUmsVisitorApplyStatusCount(data){
        return http.post(`/server/visitor/apply/selectUmsVisitorApplyStatusCount`,data);
    },
    generateQrcode(){
        return http.get(`/server/visitor/apply/generateQrcode`);
    },
    queryUmsVisitorEchartCount(data){
        return http.post(`/server/visitor/apply/queryUmsVisitorEchartCount`, data);
    },
    getShareInfo(shareCode) {
        return http.get(`/server/visitor/apply/shareInfo/${shareCode}`);
    },
    submitShareConfirmStatus(data) {
        return http.upload(`/server/visitor/apply/confirmStatus`, data);
    },
    sendVisitorSms(id){
        return http.get(`/server/visitor/apply/sendSms/${id}`);
    }
}